<template>

    <div class="configure-property-wrapper" v-if="show">

        <span class="configure-property-title">{{label}}</span>

        <label class="configure-property">

            <slot></slot>

        </label>

    </div>

</template>

<script>
    export default {
        name: "ConfigureProperty",
        props: {
            show: {
                type: Boolean,
                default: true
            },
            label: {
                type: String,
                default: ''
            }
        }
    }
</script>